import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, catchError, map, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TokenManagerService {

  private readonly tokenUrl = 'https://api.opendata.energy/oauth/token';
  private readonly clientId = 'e728a4e6-c0fa-066d-596e-d6e8ee2c0066';
  private readonly clientSecret = 'xsjQVsw1mXAK7pH6U0opGx11ILXCuHl4WeHSd7lURDOa';

  constructor(private http: HttpClient) { }

  /**
   * Gets a new client token for ConsentSDK
   * Makes an API call to the OpenData Energy OAuth endpoint
   * @returns Observable<string> The client token
   */
  getNewToken(): Observable<string> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const body = new URLSearchParams({
      'grant_type': 'client_credentials',
      'client_id': this.clientId,
      'client_secret': this.clientSecret
    }).toString();

    return this.http.post<{access_token: string, token_type: string, expires_in: number}>(
      this.tokenUrl, 
      body, 
      { headers }
    ).pipe(
      map(response => response.access_token),
      catchError(error => {
        console.error('Error getting token:', error);
        return throwError(() => new Error('Failed to get access token from OAuth endpoint'));
      })
    );
  }
}
